import { Box, Chip, Tooltip } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";

const OtherServiceTable = ({otherServiceBooking}) => {


  const columns = [
    { field: "displayIndex", headerName: "No", width: 90 },
    { field: "id", headerName: "ID", width: 90 },
    {
        field: "description",
        headerName: "Booking Description",
        width: 300,
      },
    { field: "name", headerName: "Customer Name", width: 150 },
    { field: "phone", headerName: "Customer Number", width: 150 },
    { field: "address", headerName: "Customer Address", width: 170 },
    {
      field: "created_at",
      headerName: "Booked at",
      width: 200,
      renderCell: (params) => {
        const rawDate = params.row?.created_at;
    
        if (!rawDate) return "-";
    
        const dateObj = new Date(rawDate);
    
        if (isNaN(dateObj.getTime())) return "-";
    
        const formattedDate = dateObj.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        });
    
        const formattedTime = dateObj.toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
    
        return (
          <div style={{ lineHeight: "1.3", padding: "8px 0" }}>
            <span style={{ fontWeight: "500" }}>{formattedDate}</span>
            <br />
            <span style={{ color: "#666", fontSize: "0.85rem" }}>
              {formattedTime}
            </span>
          </div>
        );
      },
    },    { field: "worker_name", headerName: "Worker", width: 150 },
    {
      field: "status",
      headerName: "Status",
      width: 150,
      renderCell: (params) => {
        let chipColor;

        switch (params.value) {
          case "Waiting":
            chipColor = "warning";
            break;
          case "Accepted":
            chipColor = "success";
            break;
          case "Cancelled":
            chipColor = "error";
            break;
          case "Estimated":
            chipColor = "primary";
            break;
          case "Completed":
            chipColor = "secondary";
            break;
          default:
            chipColor = "default";
        }

        return (
          <Chip
            label={params.value}
            color={chipColor}
            style={{
              color: "white",
              minWidth: "100px",
            }}
          />
        );
      },
    },
    {
      field: "is_booked",
      headerName: "Booking Status",
      width: 150,
      renderCell: (params) => {
        const isBooked = params.value; 
        
        const tooltipTitle = isBooked ? params.row.booked_method || "N/A" : ""; 
    
        return (
          <Tooltip
            title={tooltipTitle}
            arrow
            placement="top"
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#333",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: "bold",
                  padding: "8px",
                  borderRadius: "6px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                },
              },
            }}
          >
            <span
              style={{
                color: isBooked ? "green" : "red",
                fontWeight: "bold",
                minWidth: "100px",
                display: "inline-block",
                textAlign: "center",
                cursor: isBooked ? "pointer" : "default",
              }}
            >
              {isBooked ? "₹100 Taken" : "-"}
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "is_paid",
      headerName: "Final Payment Status",
      width: 170,
      renderCell: (params) => (
        <span style={{ color: params.value ? "green" : "red", fontWeight: "bold"}}>
          {params.value ? "Paid" : "Pending"}
        </span>
      ),
    },
    {
      field: "rating",
      headerName: "Rating",
      width: 150,
      renderCell: (params) => {
        const rating = params.value?.rating || "No Rating";
        const comment = params.value?.comment;
  
        const ratingColors = {
          Excellent: "success",
          Good: "primary",
          Satisfied: "info",
          "Not Satisfied": "warning",
          Poor: "error",
          "No Rating": "default",
        };
    
        return (
          <Tooltip
            title={comment ? comment : ""}
            arrow
            placement="top"
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#333",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: "bold",
                  padding: "8px",
                  borderRadius: "6px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                },
              },
            }}
          >
            <Chip
              label={rating}
              color={ratingColors[rating] || "default"}
              sx={{ cursor: comment ? "pointer" : "default" }}
            />
          </Tooltip>
        );
      },
    },
    { field: "payment_method", headerName: "Payment Method", width: 130 },
    { field: "booking_price", headerName: "Booking Price", width: 130 },
    {
      field: "total_price",
      headerName: "Total Price",
      width: 150,
    },
    {
      field: "payable_amount",
      headerName: "Payable Amount",
      width: 150,
    },

    {
        field: "service_charge",
        headerName: "Service Charge",
        width: 120,
      },
    {
      field: "service_charge_comment",
      headerName: "Service Charge Comment ",
      width: 250,
    },
  
  ];
  return (
    <Box
      sx={{
        flexGrow: 1,
        maxWidth: { xs: 650, sm: 682, lg: 1350 },
        bgcolor: "background.paper",
      }}
    >
      <DataGrid
        rows={otherServiceBooking}
        columns={columns}
        disableSelectionOnClick
        pageSizeOptions={[25, 50, 100]}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 25,
            },
          },
        }}
      />
    </Box>
  );
};

export default OtherServiceTable;
